module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/crm/contacts/contacts.html
// module id = 405
// module chunks = 0